<template>
  <div class="text-[#292C2E] text-base font-bold">
    Your account is in review
  </div>
  <p class="my-1 text-[#292C2E] text-sm md:text-base">
    It will take up to 5 business days. We may have additional verification questions.
  </p>
  <a href="#" class="text-sm md:text-base text-[#008AFC]">Contact support</a>
</template>
